// SwitchOnOff.tsx — interrupteur ON / OFF (2026-10-29)
//
// Le curseur coulisse d'un bout à l'autre de la piste, qui change de couleur et affiche
// l'état en toutes lettres : le sens ne repose pas sur la seule couleur. La transition reste
// active même avec « réduire les animations » : c'est un déplacement de 40 px sur 200 ms qui
// porte l'information du geste, pas un effet décoratif.
//
// Utilisé par la carte « Reporter Kleon » du panneau Mon compte et par la fiche créateur du
// superadmin (AdminSheet). Les autres interrupteurs de l'application gardent `Toggle`.

import React from 'react';

interface Props {
  checked     : boolean;
  onChange    : () => void;
  /** id de l'élément qui nomme l'interrupteur (prioritaire sur ariaLabel). */
  labelledBy? : string;
  ariaLabel?  : string;
  disabled?   : boolean;
}

const SwitchOnOff: React.FC<Props> = ({ checked, onChange, labelledBy, ariaLabel, disabled = false }) => (
  <button type="button" role="switch" aria-checked={checked} aria-labelledby={labelledBy}
          aria-label={labelledBy ? undefined : ariaLabel} disabled={disabled} onClick={onChange}
          className={`relative h-8 w-[4.5rem] shrink-0 rounded-full shadow-inner transition-colors duration-200 ease-in-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-400 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-900 disabled:cursor-not-allowed disabled:opacity-50 ${checked ? 'bg-emerald-500' : 'bg-slate-600'}`}>
    <span aria-hidden className={`pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-[10px] font-bold tracking-wider text-emerald-950 transition-opacity duration-200 ${checked ? 'opacity-100' : 'opacity-0'}`}>ON</span>
    <span aria-hidden className={`pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-[10px] font-bold tracking-wider text-slate-300 transition-opacity duration-200 ${checked ? 'opacity-0' : 'opacity-100'}`}>OFF</span>
    <span aria-hidden className={`absolute left-1 top-1 h-6 w-6 rounded-full bg-white shadow-md transition-transform duration-200 ease-in-out ${checked ? 'translate-x-10' : 'translate-x-0'}`} />
  </button>
);

export default SwitchOnOff;
